/* LL 85A: server content remains usable without JS; no network requests. */
(() => {
  if (customElements.get('ll-social-proof')) return;
  customElements.define('ll-social-proof', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const link = this.querySelector('[data-reviews-link]');
      const target = () => {
        const reviews = document.getElementById('ll-product-reviews') || document.querySelector('ll-meal-reviews,.ll-reviews[data-mode="product"]') || document.getElementById('ll-customer-reviews');
        if (reviews && !reviews.id) reviews.id = 'll-product-reviews';
        return reviews;
      };
      const updateLink = () => {
        if (!link) return;
        const reviews = target();
        const hidden = !reviews;
        if (link.hidden !== hidden) link.hidden = hidden;
        if (reviews) {
          const href = '#' + reviews.id;
          if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        }
      };
      updateLink();
      document.addEventListener('shopify:section:load', updateLink, { signal });
      if (link) {
        link.addEventListener('click', event => {
          const reviews = target();
          if (!reviews || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const hadTabindex = reviews.hasAttribute('tabindex');
          if (!hadTabindex) reviews.tabIndex = -1;
          reviews.focus({ preventScroll: true });
          reviews.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          if (!hadTabindex) reviews.addEventListener('blur', () => reviews.removeAttribute('tabindex'), { once: true, signal });
        }, { signal });
      }
      const pause = this.querySelector('.ll-social-proof__pause');
      if (pause) {
        pause.hidden = false;
        pause.addEventListener('click', () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          pause.setAttribute('aria-pressed', String(paused));
          pause.setAttribute('aria-label', paused ? 'Resume review animation' : 'Pause review animation');
          pause.textContent = paused ? '▶' : 'Ⅱ';
        }, { signal });
        this.classList.add('ll-social-proof--ready');
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
